import { render } from "./FlowHistory.vue?vue&type=template&id=8084e854"
import script from "./FlowHistory.vue?vue&type=script&lang=js"
export * from "./FlowHistory.vue?vue&type=script&lang=js"

import exportComponent from "d:\\buildagent\\agent-cidev01-a\\205\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__